import { createSelector } from 'reselect';

import getIsQuickCommerce from '@core/reducers/menu/selectors/getIsQuickCommerce';
import getMenu from './getMenu';
import getGroceriesMenu from './getGroceriesMenu';

const getMenuSections = createSelector(
  getMenu,
  getGroceriesMenu,
  getIsQuickCommerce,
  (menu, groceriesMenu, isQC) => {
    if (isQC) return groceriesMenu?.sections || [];
    return menu?.sections || [];
  },
);

export default getMenuSections;
